import { useTranslation } from "react-i18next"

import { cn } from "@f2e/ui/lib/utils"
import { Badge } from "@f2e/ui/components/base"

import { ClientChannelType } from "@/types"

export interface ChannelTypeBadgeProps {
  type: ClientChannelType
  className?: string
}

const getTypeColor = (type: ClientChannelType) => {
  switch (type) {
    case ClientChannelType.WEB:
      return "bg-blue-100 text-blue-800 dark:bg-blue-900 dark:text-blue-300"
    case ClientChannelType.WIDGET:
      return "bg-amber-100 text-amber-800 dark:bg-amber-900 dark:text-amber-300"
    case ClientChannelType.BROWSER_EXTENSION:
      return "bg-purple-100 text-purple-800 dark:bg-purple-900 dark:text-purple-300"
    case ClientChannelType.SLACK:
      return "bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-300"
    case ClientChannelType.LINE:
      return "bg-emerald-100 text-emerald-800 dark:bg-emerald-900 dark:text-emerald-300"
    case ClientChannelType.MESSENGER:
      return "bg-sky-100 text-sky-800 dark:bg-sky-900 dark:text-sky-300"
    case ClientChannelType.INSTAGRAM:
      return "bg-rose-100 text-rose-800 dark:bg-rose-900 dark:text-rose-300"
    default:
      return "bg-gray-100 text-gray-800 dark:bg-gray-800 dark:text-gray-300"
  }
}

export const ChannelTypeBadge = ({
  type,
  className,
}: ChannelTypeBadgeProps) => {
  const { t } = useTranslation()

  const getTypeLabel = (type: ClientChannelType) => {
    switch (type) {
      case ClientChannelType.WEB:
        return t("workspace.channels.types.webShort")
      case ClientChannelType.WIDGET:
        return t("workspace.channels.types.widgetShort")
      case ClientChannelType.BROWSER_EXTENSION:
        return t("workspace.channels.types.browserExtensionShort")
      case ClientChannelType.SLACK:
        return t("workspace.channels.types.slackShort")
      case ClientChannelType.LINE:
        return t("workspace.channels.types.lineShort")
      case ClientChannelType.MESSENGER:
        return t("workspace.channels.types.messengerShort")
      case ClientChannelType.INSTAGRAM:
        return t("workspace.channels.types.instagramShort")
      default:
        return type
    }
  }

  return (
    <Badge
      variant="secondary"
      className={cn("text-xs", getTypeColor(type), className)}
    >
      {getTypeLabel(type)}
    </Badge>
  )
}

export default ChannelTypeBadge
